import { ReactNode } from 'react';

export const PanelEmpty = ({ children }: { children: ReactNode }) => (
  <div
    style={{
      margin: '4px 10px 10px',
      padding: '14px 12px',
      border: '1px dashed var(--bui-border-1)',
      borderRadius: 'var(--bui-radius-2)',
      fontSize: 12,
      color: 'var(--bui-fg-secondary)',
      textAlign: 'center',
    }}
  >
    {children}
  </div>
);
